import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class CVEXporter  {
    _originalTypeClassName = "zERP.BO.CVEXporter";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
CVEXporter.translate = translateService;
}
this.CVEXporterKey = null;
this._key = this.CVEXporterKey = 0; 
}

static translate: TranslateService;
_key: any;
private _CVEXporterKey:any;
get CVEXporterKey(): any {
    return this._CVEXporterKey;
  }
set CVEXporterKey(value: any) {
    this._CVEXporterKey = value;
    this._key = value;
  }

static AcknoledgedYearsCTCE(employee: any): any{let exp = employee?.CTExperienceAnalysis;
if (exp == null) {exp = new Domain.WorkExperienceAnalysis();}
return CLMS.Framework.String.Format("{0} έτη, {1} μήνες και {2} ημέρες", exp?.ExperienceInYears, exp?.ExperienceInMonths, exp?.ExperienceInDays);
}
static AcknoledgedYearsDayOffCE(employee: any): any{let exp = employee?.DayOffExperienceAnalysis;
if (exp == null) {exp = new Domain.WorkExperienceAnalysis();}
return CLMS.Framework.String.Format("{0} έτη, {1} μήνες και {2} ημέρες", exp?.ExperienceInYears, exp?.ExperienceInMonths, exp?.ExperienceInDays);
}
static AcknoledgedYearsSalaryCE(employee: any): any{let exp = employee?.WorkExperienceAnalysis;
if (exp == null) {exp = new Domain.WorkExperienceAnalysis();}
return CLMS.Framework.String.Format("{0} έτη, {1} μήνες και {2} ημέρες", exp?.ExperienceInYears, exp?.ExperienceInMonths, exp?.ExperienceInDays);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.CVEXporterKey == null || $this.CVEXporterKey == 0;
            }


}